import { Component, Inject, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { filter } from 'rxjs/operators';
import { CustomValidators, TokenService } from 'viggo-sistemas-core-web';
import { ICodigoSegContribuinte } from '../../../../shared/model/csc.model';
import { CodigoSegContribuinteService } from '../../../../shared/services/csc.service';

@Component({
  selector: 'app-fast-csc',
  templateUrl: './fast-csc.component.html',
  styleUrls: ['./fast-csc.component.scss'],
  providers: [CodigoSegContribuinteService]
})
export class FastCodigoSegContribuinteComponent implements OnInit {
  form: UntypedFormGroup;
  entity: ICodigoSegContribuinte;
  loading = false;

  constructor(
    protected fb: UntypedFormBuilder,
    protected entityService: CodigoSegContribuinteService,
    protected snackBar: MatSnackBar,
    protected dialogRef: MatDialogRef<FastCodigoSegContribuinteComponent>,
    protected tokenService: TokenService,
    @Inject(MAT_DIALOG_DATA) data: ICodigoSegContribuinte
  ) {
    this.entity = data;
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      id_csc: [
        this.entity ? this.entity.id_csc : null,
        [
          Validators.required,
          Validators.maxLength(10),
          CustomValidators.existSpecialChar()
        ]
      ],
      csc: [
        this.entity ? this.entity.csc : '',
        [
          Validators.required,
          Validators.minLength(16),
          Validators.maxLength(36),
          CustomValidators.existSpecialChar()
        ]
      ]
    });
  }

  notText(event) {
    if (
      (!/^\d+$/.test(event.key) || /[`,.]/.test(event.key)) &&
      event.key !== 'Backspace' &&
      event.key !== 'Delete' &&
      event.key !== 'Tab' &&
      event.key !== 'ArrowLeft' &&
      event.key !== 'ArrowRight' &&
      !event.ctrlKey
    )
      return false;
  }

  onSubmit() {
    this.loading = true;
    var entity = {
      domain_org_id: this.tokenService.getDomain().id,
      ...this.form.value
    } as ICodigoSegContribuinte;
    if (this.form.valid) {
      if (this.entity.id) {
        entity.id = this.entity.id;
        this.entityService
          .update(entity)
          .pipe(filter(result => !!result))
          .subscribe(
            csc => {
              this.loading = false;
              this.dialogRef.close(csc);
              this.snackBar.open(
                'Código segurança contribuinte atualizado com sucesso.',
                'X',
                {
                  duration: 2000,
                  horizontalPosition: 'right',
                  verticalPosition: 'top',
                  panelClass: ['msg-success']
                }
              );
            },
            () => {
              this.loading = false;
              this.snackBar.open(
                'Erro ao atualizar código segurança contribuinte.',
                'X',
                {
                  duration: 2000,
                  horizontalPosition: 'right',
                  verticalPosition: 'top',
                  panelClass: ['msg-error']
                }
              );
            }
          );
      } else {
        this.entityService
          .insert(entity)
          .pipe(filter(result => !!result))
          .subscribe(
            csc => {
              this.loading = false;
              this.dialogRef.close(csc);
              this.snackBar.open(
                'Código segurança contribuinte cadastrado com sucesso.',
                'X',
                {
                  duration: 2000,
                  horizontalPosition: 'right',
                  verticalPosition: 'top',
                  panelClass: ['msg-success']
                }
              );
            },
            () => {
              this.loading = false;
              this.snackBar.open(
                'Erro ao cadastrar código segurança contribuinte.',
                'X',
                {
                  duration: 2000,
                  horizontalPosition: 'right',
                  verticalPosition: 'top',
                  panelClass: ['msg-error']
                }
              );
            }
          );
      }
    }
  }
}
